// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__15n3h","rootSuccess":"CompleteLink_rootSuccess__7zmB4","rootFailure":"CompleteLink_rootFailure__3x18i","isDisabled":"CompleteLink_isDisabled__RMOPB"};